var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHddStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.576,
    height: 34.128,
    viewBox: "0 0 25.576 34.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2536"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 885",
    d: "M171.505 153.243v14.475a2.382 2.382 0 0 1-1.785 2.453 3.333 3.333 0 0 1-.8.088c-6.8 0-13.59-.007-20.385.011a2.521 2.521 0 0 1-2.607-2.61q.037-14.458 0-28.915a2.52 2.52 0 0 1 2.613-2.6c6.8.019 13.59.007 20.385.009a2.412 2.412 0 0 1 2.525 1.916 3.77 3.77 0 0 1 .05.768q.006 7.201.004 14.405zm-17.665 8.864a10.133 10.133 0 0 0 11.544-16.514 10.13 10.13 0 0 0-15.1 13.252c-.359.279-.724.553-1.079.84a2.525 2.525 0 0 0-.968 2.681 2.45 2.45 0 0 0 1.984 1.959 2.516 2.516 0 0 0 2.648-.977c.331-.413.651-.83.972-1.242zm9.15 7.086c1.678 0 3.357.012 5.035 0a1.868 1.868 0 1 0-.11-3.733h-9.869a2.9 2.9 0 0 0-.467.041 1.862 1.862 0 0 0 .376 3.692c1.678.007 3.357 0 5.035 0zm-12.261-30.109a1.86 1.86 0 1 0-1.85 1.87 1.871 1.871 0 0 0 1.85-1.87zm19.71.009a1.86 1.86 0 1 0-1.857 1.86 1.863 1.863 0 0 0 1.857-1.86zm-19.71 28.234a1.86 1.86 0 1 0-1.855 1.865 1.87 1.87 0 0 0 1.855-1.865z",
    transform: "translate(-145.93 -136.142)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 886",
    d: "m192.525 242.542.757-.981c.685-.885 1.378-1.764 2.049-2.659a.443.443 0 0 1 .526-.191 4.252 4.252 0 0 0 1.93-8.279 4.01 4.01 0 0 0-4.3 1.347 4.126 4.126 0 0 0-.685 4.461c.041.1.09.2.147.325l-1.91 1.479-1.88 1.456a9.069 9.069 0 1 1 3.367 3.042z",
    transform: "translate(-183.916 -217.479)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 887",
    d: "M255.892 297.311c.538-.968.559-1.617-.01-2.124-.922-.821-1.727-.348-2.474.328a3.136 3.136 0 0 1 .716-3.7 3.2 3.2 0 0 1 5.019 3.773 3.107 3.107 0 0 1-3.251 1.723z",
    transform: "translate(-243.477 -277.116)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 888",
    d: "M182.833 352.052a1.484 1.484 0 0 1 .551-1.254q3.612-2.812 7.235-5.611a.387.387 0 0 1 .57 0c.188.189.128.379-.019.568q-2.136 2.736-4.267 5.476c-.453.582-.88 1.185-1.348 1.754a1.445 1.445 0 0 1-1.538.5 1.482 1.482 0 0 1-1.127-1.084 2.1 2.1 0 0 1-.057-.349z",
    transform: "translate(-179.528 -326.348)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 889",
    d: "M276.791 476.923h-4.969a.8.8 0 0 1-.835-1.064.756.756 0 0 1 .611-.513 2.266 2.266 0 0 1 .4-.023h9.736a.809.809 0 1 1-.009 1.6q-2.467.003-4.934 0z",
    transform: "translate(-259.739 -444.942)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 890",
    d: "M171.419 160.934a.794.794 0 1 1-.794-.783.788.788 0 0 1 .794.783z",
    transform: "translate(-167.69 -158.001)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 891",
    d: "M389.986 160.93a.789.789 0 0 1 .8-.778.8.8 0 0 1 .788.794.794.794 0 1 1-1.588-.016z",
    transform: "translate(-368.127 -158.001)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 892",
    d: "M171.422 476.165a.789.789 0 0 1-.778.8.8.8 0 1 1 .778-.8z",
    transform: "translate(-167.693 -444.987)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHddStatus);
export default __webpack_public_path__ + "static/media/HDD_status.d38e0fa0beb0b85fecf8668d700a3efa.svg";
export { ForwardRef as ReactComponent };